import React from "react";
import styled from "styled-components";

type FileItem = {
    accountId?: string;
    fileId?: number;
    fileKey?: string;
    fileOrgname?: string;
    fileType?: string;
    fileUrl?: string;
};

interface UploadedFile extends File {
    fileOrgname?: string;
}

type FileListProps = {
    files: (UploadedFile & FileItem)[];
    deleteFile: (file: UploadedFile) => void;
    deleteUpdatedFile: (file: UploadedFile) => void;
    mode?: string;
    downloadMutate?: (params: {
        data: any;
        type?: string;
        isDonwloadBtn?: boolean;
    }) => void;
};

export const FileList: React.FC<FileListProps> = ({
                                                      files,
                                                      deleteFile,
                                                      deleteUpdatedFile,
                                                      mode,
                                                      downloadMutate,
                                                  }) => {
    const download = (item: FileItem & UploadedFile) => {
        if ((mode === "R" || mode === "RU") && item?.fileId && downloadMutate) {
            downloadMutate({data: item});
        }
    };

    return (
        <S.FileNameContainer>
            {files.map((item) => (
                <div
                    className="item"
                    key={item.name || item.fileId}
                    role="button"
                    onClick={() => download(item)}
                >
                    {item?.name && <a href={void 0} className="link-underline">{item.name}</a>}
                    {item?.fileOrgname && <a href={void 0} className="link-underline">{item.fileOrgname}</a>}

                    {mode !== "R" && (
                        <img
                            className="ms-1"
                            onClick={(event: any) => {
                                event.stopPropagation();
                                item?.name ? deleteFile(item) : deleteUpdatedFile(item);
                            }}
                            src={process.env.PUBLIC_URL + "/assets/images/icon_del_file.png"}
                            alt=""
                        />
                    )}
                </div>
            ))}
        </S.FileNameContainer>
    );
};

const S = {
    FileNameContainer: styled.div`
        display: flex;
        gap: 8px;
        flex-wrap: wrap;

        .item {
            display: flex;
            align-items: center;
            justify-content: space-between;

            span {
                margin-top: 0 !important;
                line-height: 18px;
                margin-right: 4px;
            }
        }
    `,
};
